import { CustomDialog } from "@/components/ui-elements";
// import { useEditWorkflow } from "@/features/folder/api/editWorkflow";
import { useFolderData } from "@/components/ui-elements/SideMenu/hooks/useFolderData";
import { TextField } from "@mui/material";
import type { ForwardRefRenderFunction } from "react";
import { forwardRef, useState } from "react";

interface EditFolderNamePopupProps {
  folderId: string;
  folderLabel: string;
  onClose: () => void;
}

const EditFolderNamePopupComponent: ForwardRefRenderFunction<
  HTMLDivElement,
  EditFolderNamePopupProps
> = ({ folderId, folderLabel, onClose }, _) => {
  const { updateFolderName } = useFolderData();
  const [newFolderName, setNewFolderName] = useState(folderLabel);
  // const editFolderNameMutation = useEditWorkflow();

  const handleNext = async () => {
    if (!folderId) {
      return;
    }

    try {
      await updateFolderName(folderId, newFolderName);
      if (onClose) {
        onClose();
      }
    } catch (error) {
      // Error handling
    }
  };

  return (
    <CustomDialog
      title="フォルダ名を編集"
      description="フォルダの新しい名前を入力してください。"
      open={true}
      onClose={onClose}
      primaryButtonText="登録する"
      primaryButtonAction={handleNext}
      primaryButtonDisabled={newFolderName.trim() === ""}
      secondaryButtonText="キャンセル"
      secondaryButtonAction={onClose}
    >
      <TextField
        autoFocus
        margin="dense"
        id="name"
        placeholder="フォルダ名"
        type="text"
        fullWidth
        value={newFolderName}
        onChange={(e) => setNewFolderName(e.target.value)}
        label="フォルダ名"
      />
    </CustomDialog>
  );
};

const EditFolderNamePopup = forwardRef(EditFolderNamePopupComponent);
EditFolderNamePopup.displayName = "EditFolderNamePopup";

export default EditFolderNamePopup;
